import React, { useState } from 'react'
import { Form, Card, Typography, Button, Space, message, Divider } from 'antd'
import { ArrowLeftOutlined, CheckOutlined } from '@ant-design/icons'
import { useDispatch } from 'react-redux'
import RefundForm from './RefundForm'
import { createRefund } from '../../backend-integration/api/paymentAllocation'
import coreReducer from '../../../../core/utils/reducer'

const { Title } = Typography

const RefundWrapper = ({ preSelectedPatient, tabKey }) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()

  const handleSubmit = async (values) => {
    setLoading(true)
    try {
      await createRefund({
        ...values,
        patientId: preSelectedPatient._id,
        billingId: preSelectedPatient.billingId
      })

      message.success('Refund request submitted successfully and is pending approval')

      // Close the current tab
      dispatch(coreReducer.actions.closeTab(tabKey))
    } catch (error) {
      console.error('Failed to create refund:', error)
      message.error('Failed to submit refund request')
    } finally {
      setLoading(false)
    }
  }

  const handleGoBack = () => {
    // Close the current tab
    dispatch(coreReducer.actions.closeTab(tabKey))
  }

  return (
    <Card>
      <div style={{ marginBottom: 16 }}>
        <Button type='text' icon={<ArrowLeftOutlined />} onClick={handleGoBack} style={{ marginBottom: 8 }}>
          Back to Account
        </Button>
        <Title level={3} style={{ margin: 0 }}>
          Process Refund
        </Title>
        <p style={{ color: '#666', margin: '8px 0 0 0' }}>
          Patient: {preSelectedPatient.name} (ID: {preSelectedPatient.billingId})
        </p>
      </div>

      <Form form={form} layout='vertical' onFinish={handleSubmit}>
        <RefundForm form={form} preSelectedPatient={preSelectedPatient} />

        <Divider />

        <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
          <Space>
            <Button onClick={handleGoBack}>Cancel</Button>
            <Button type='primary' htmlType='submit' loading={loading} icon={<CheckOutlined />}>
              Submit Refund Request
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Card>
  )
}

export default RefundWrapper
